import { render, staticRenderFns } from "./RedPacketPrizeUpdatePane.vue?vue&type=template&id=6d751c00&scoped=true"
import script from "./RedPacketPrizeUpdatePane.vue?vue&type=script&lang=js"
export * from "./RedPacketPrizeUpdatePane.vue?vue&type=script&lang=js"
import style0 from "./RedPacketPrizeUpdatePane.vue?vue&type=style&index=0&id=6d751c00&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d751c00",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d751c00')) {
      api.createRecord('6d751c00', component.options)
    } else {
      api.reload('6d751c00', component.options)
    }
    module.hot.accept("./RedPacketPrizeUpdatePane.vue?vue&type=template&id=6d751c00&scoped=true", function () {
      api.rerender('6d751c00', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/activity/red_packet/components/RedPacketPrizeUpdatePane.vue"
export default component.exports